/**
 * Default SisPDV logos - used as fallback when instance has no custom logo
 * 
 * Logo variants:
 * - favicon: Small icon for browser tab
 * - icon-dark: Icon on dark background
 * - icon-light: Icon on light/white background
 * - logo-white: Horizontal logo in white (for dark backgrounds)
 * - logo-horizontal-dark: Horizontal logo for dark backgrounds
 * - logo-horizontal-light: Horizontal logo for light backgrounds
 * - logo-full: Full vertical logo with icon + text
 * - logo-vertical-dark: Vertical logo for dark backgrounds
 */

const DEFAULT_LOGOS = {
  favicon: '/logos/favicon.png',
  iconDark: '/logos/icon-dark-rounded.png',
  iconLight: '/logos/icon-white-bg.png',
  logoWhite: '/logos/logo-white.png',
  logoHorizontalDark: '/logos/logo-horizontal-dark.png',
  logoHorizontalLight: '/logos/logo-horizontal-white-bg.png',
  logoFull: '/logos/logo-full-color.png',
  logoVerticalDark: '/logos/logo-vertical-dark.png',
};

/**
 * Get the appropriate logo based on instance settings and theme
 * @param {object} instance - Current instance object (may have settings.logo_url, settings.favicon_url)
 * @param {string} variant - Which logo variant to use
 * @returns {string} URL of the logo to display
 */
export function getLogo(instance, variant = 'iconDark') {
  const logoUrl = instance?.settings?.logo_url || instance?.logo_url;
  const faviconUrl = instance?.settings?.favicon_url || instance?.favicon_url;
  
  if (variant === 'favicon' && faviconUrl) {
    return faviconUrl;
  }
  
  if (logoUrl && variant !== 'favicon') {
    return logoUrl;
  }
  
  return DEFAULT_LOGOS[variant] || DEFAULT_LOGOS.iconDark;
}

/**
 * Get the business name from instance or default
 * @param {object} instance - Current instance object
 * @returns {string} Business name to display
 */
export function getBusinessName(instance) {
  return instance?.settings?.business_name || instance?.business_name || instance?.name || 'SisPDV';
}

export default DEFAULT_LOGOS;
